import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import type { TierId } from '@/types';

interface CheckoutResponse {
  url: string;
}

interface PortalResponse {
  url: string;
}

const _createCheckoutSession = httpsCallable<{ tier: TierId; origin: string }, CheckoutResponse>(
  functions,
  'createCheckoutSession'
);

const _createPortalSession = httpsCallable<{ origin: string }, PortalResponse>(
  functions,
  'createPortalSession'
);

export async function startCheckout(tier: TierId): Promise<string> {
  const result = await _createCheckoutSession({ tier, origin: window.location.origin });
  return result.data.url;
}

export async function openBillingPortal(): Promise<string> {
  const result = await _createPortalSession({ origin: window.location.origin });
  return result.data.url;
}
